// extracted by mini-css-extract-plugin
export default {"button":"AssignButton_button__u7+Bm"};